/**
 * Development-only logger
 * Prevents console statements from appearing in production builds
 */
import { devLog, devWarn, devError } from './devLog';

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDevelopment) devLog(...args);
  },
  error: (...args) => {
    devError(...args);  // Always log errors
  },
  warn: (...args) => {
    if (isDevelopment) devWarn(...args);
  },
  debug: (...args) => {
    if (isDevelopment) devLog(...args);
  },
  info: (...args) => {
    if (isDevelopment) devLog(...args);
  }
};

// Also export as default for easier importing
export default logger;